import { Component, Input, inject } from "@angular/core";
import { SlotService } from "common/slot.service";
import { BaseComponent } from "process/view/base.component";
import { ComponentService } from "process/view/component.service";
import { TabType } from "process/view/type.interface";
import { SlotDirective } from "common/slot.directive";

@Component({
	selector: "stages-tab-content-dynamic",
	templateUrl: "./tab-content-dynamic.component.html",
	styleUrls: ["./tab-content-dynamic.component.scss"],
	providers: [SlotService],
	imports: [SlotDirective],
})
export class TabContentDynamicComponent extends BaseComponent {
	// TODO: Skipped for migration because:
	//  This input overrides a field from a superclass, while the superclass field
	//  is not migrated.
	@Input()
	override type?: TabType;

	constructor() {
		const componentService = inject(ComponentService);
		const slotService = inject(SlotService);

		super(componentService, slotService);
	}
}
